// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Logout_logout__LcYre {
  display: flex;
  align-items: center;
  gap: 1.4rem;
  flex-grow: 1;
  font-size: var(--text-base);
  font-weight: 500;
}
`, "",{"version":3,"sources":["webpack://./src/components/Layout/DashboardHeader/MechanicMenu/Logout/Logout.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,gBAAgB;AAClB","sourcesContent":[".logout {\n  display: flex;\n  align-items: center;\n  gap: 1.4rem;\n  flex-grow: 1;\n  font-size: var(--text-base);\n  font-weight: 500;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"logout": `Logout_logout__LcYre`
};
export default ___CSS_LOADER_EXPORT___;
